"use client";
import React from 'react';

const SelectedLocationContext = React.createContext(undefined);
const SelectedLocationProvider = SelectedLocationContext.Provider;

export { SelectedLocationContext, SelectedLocationProvider };
//# sourceMappingURL=SelectedLocationProvider.js.map
